/**
 * @public { open }
 * @public { close }
 * @public { disable }
 * @public { enable }
 */
class ReadMore {
  constructor(node, options) {
    if (!node) {
      return new Error(typeof node);
    }
    this.isExpanded = true;
    this.options = Object.assign({
      textMore: 'Читать полностью',
      textLess: 'Свернуть',
    }, options);
    this.content = node;
    this.wrapper = this.makeWrapper();
    this.footer = this.makeFooter();
    this.toggle = this.makeToggle();
    this.content.parentNode.insertBefore(this.wrapper, this.content);
    this.wrapper.appendChild(this.content);
    this.toggle.onclick = (event) => {
      if (this.isExpanded) this.close();
      else this.open();
      event.preventDefault();
    };
  }

  makeToggle() {
    const toggle = document.createElement('button');
    toggle.className = 'c-read-more__btn';
    toggle.innerText = this.options.textMore;
    toggle.style.display = 'none';
    return toggle;
  }

  makeWrapper() {
    const wrapper = document.createElement('div');
    wrapper.className = 'c-read-more';
    return wrapper;
  }

  makeFooter() {
    const footer = document.createElement('div');
    footer.className = 'c-read-more__footer';
    return footer;
  }

  open() {
    this.content.style.display = '';
    this.toggle.innerText = this.options.textLess;
    this.toggle.classList.add('is-active');
    this.wrapper.classList.add('is-active');
    this.isExpanded = true;
  }

  close() {
    this.content.style.display = 'none';
    this.toggle.innerText = this.options.textMore;
    this.toggle.classList.remove('is-active');
    this.wrapper.classList.remove('is-active');
    this.isExpanded = false;
  }

  disable() {
    this.open();
    if (this.footer.parentNode) this.footer.parentNode.removeChild(this.footer);
  }

  enable() {
    this.close();
    this.toggle.style.display = '';
    this.footer.appendChild(this.toggle);
    this.wrapper.appendChild(this.footer);
  }
}
export default ReadMore;
